import {Serializers} from "../../interfaces/serializer";
import {Matching} from "../../interfaces/matching";

export const MATCHINGS_STATE_NAME = 'matchings';

export interface MatchingsState {
  matchings: Serializers<Matching>;
  loading: boolean;
}
